import { CSSProperties, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const List = ({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <div className={twMerge("overflow-auto", className)} style={style}>
      {children}
    </div>
  );
};
